module.exports = __webpack_public_path__ + "img/icon16-call-in-danger.c12a7e03.svg";